namespace $.$$ {

	$mol_style_define( $shm_ba_filter_section, {
		display: 'flex',
		flex: {
			direction: 'column',
		},

		Title: {
			display: 'grid',
			gridTemplateColumns: 'auto max-content minmax(0, 1fr)',
			alignItems: 'center',
			font: {
				weight: 'bold',
				size: '16px',
			},
		},
		Label: {
			display: 'flex',
			alignItems: 'baseline',
			gap: '8px',
			minWidth: 0,
			whiteSpace: 'nowrap',
		},
		Expand: {
			margin: {
				left: '-0.5rem',
			},
			// padding: {
			// 	right: '0.25rem',
			// },
		},
		Tools: {
			justifyContent: 'flex-end',
			minWidth: 0,
			width: '100%',
			maxWidth: '100%',
			overflow: 'hidden',
			':empty': {
				display: 'none',
			},
		},
		Count: {
			color: $mol_theme.shade,
			font: {
				weight: 'normal',
				size: '13px',
			},
			padding: {
				right: '0.25rem',
			},
			':empty': {
				display: 'none',
			},
		},
		$mol_search: {
			font: {
				weight: 'normal',
				size: '13px',
			},
			minHeight: 0,
			minWidth: 0,
			maxWidth: '100%',
			width: '100%',
			alignSelf: 'stretch',
			flex: {
				shrink: 1,
				basis: 0,
			},
			Anchor: {
				display: 'flex',
				minWidth: 0,
				width: '100%',
				maxWidth: '100%',
				overflow: 'hidden',
			},
			$mol_string: {
				minWidth: 0,
				width: 0,
				maxWidth: '100%',
				flex: {
					grow: 1,
					shrink: 1,
					basis: 0,
				},
			},
			Query: {
				minHeight: '28px',
				minWidth: 0,
				width: 0,
				flex: {
					grow: 1,
					shrink: 1,
					basis: 0,
				},
				padding: {
					left: '6px',
					right: '6px',
					top: '2px',
					bottom: '2px',
				},
			},
			Clear: {
				minHeight: '28px',
				minWidth: '28px',
				width: '28px',
				flex: {
					shrink: 0,
				},
				padding: {
					left: 0,
					right: 0,
				},
			},
		},
	} )

}
